import React from "react";
import {
    Box,
    FormControl,
    FormHelperText,
    InputLabel,
    MenuItem,
    Paper,
    Select,
    Typography,
} from "@material-ui/core";
import { Settings, Layers, Description } from "@material-ui/icons";
import { i18n } from "../../translate/i18n";
import PromptLayersManager from "../PromptLayersManager";
import PromptDocumentsManager from "../PromptDocumentsManager";

// D8.3.5b — Sección "Modo de trabajo" + gestor condicional layers/pdfs. Sin acople a Formik.
export default function PromptWorkModeSection({
    classes,
    promptId,
    companyId,
    selectedWorkMode,
    setSelectedWorkMode,
}) {
    return (
        <>
            <Paper className={classes.formSection}>
                <Typography className={classes.sectionTitle}>
                    <Settings style={{ marginRight: 8 }} />
                    {i18n.t("promptModal.sections.workMode")}
                </Typography>
                <FormControl fullWidth margin="dense" variant="outlined" className={`${classes.formField} ${classes.formControlDynamic}`}>
                    <InputLabel>{i18n.t("promptModal.fields.workModeLabel")}</InputLabel>
                    <Select
                        key={`workmode-select-${promptId}-${selectedWorkMode}`}
                        label={i18n.t("promptModal.fields.workModeLabel")}
                        value={selectedWorkMode || "layers"}
                        onChange={(e) => {
                            console.log("[PromptModal] Cambiando workMode de", selectedWorkMode, "a", e.target.value);
                            setSelectedWorkMode(e.target.value);
                        }}
                    >
                        <MenuItem value="layers">
                            <Box display="flex" alignItems="center">
                                <Layers style={{ marginRight: 8 }} />
                                <Typography>{i18n.t("promptModal.fields.workModeLayers")}</Typography>
                            </Box>
                        </MenuItem>
                        <MenuItem value="pdfs">
                            <Box display="flex" alignItems="center">
                                <Description style={{ marginRight: 8 }} />
                                <Typography>{i18n.t("promptModal.fields.workModePdfs")}</Typography>
                            </Box>
                        </MenuItem>
                    </Select>
                    <FormHelperText>
                        {selectedWorkMode === 'layers'
                            ? i18n.t("promptModal.fields.workModeHintLayers")
                            : i18n.t("promptModal.fields.workModeHintPdfs")}
                    </FormHelperText>
                </FormControl>
            </Paper>

            {selectedWorkMode === 'layers' ? (
                <Paper className={classes.formSection}>
                    <PromptLayersManager
                        promptId={promptId}
                        companyId={companyId}
                        onLayersChange={(layers) => {
                            // Callback opcional para cuando cambien las layers
                            console.log("Layers actualizadas:", layers.length);
                        }}
                    />
                </Paper>
            ) : (
                <Paper className={classes.formSection}>
                    <PromptDocumentsManager
                        promptId={promptId}
                        companyId={companyId}
                    />
                </Paper>
            )}
        </>
    );
}
